import { Fragment, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";

type AssetModalProps = {
  imagePaths: string[]; // Array of image paths
  baseUrl: string; // The host URL to prepend to the image paths
  isOpen: boolean; // Modal open state
  setOpen: (open: boolean) => void; // Function to close the modal
};

export default function AssetModal({
  imagePaths,
  baseUrl,
  isOpen,
  setOpen,
}: AssetModalProps) {
  const cancelButtonRef = useRef(null);
  console.log(baseUrl);

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl sm:p-6">
                <div>
                  <h2 className="text-lg font-medium leading-6 text-gray-900">
                    Asset Images
                  </h2>
                  <p className="mt-1 text-sm text-gray-500">
                    View the asset images below.
                  </p>
                </div>

                <div className="mt-6">
                  {imagePaths.length === 0 ? (
                  <p className="text-sm text-gray-500">
                    No images associated with this device.
                  </p>
                  ) : (
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                    {imagePaths.map((imagePath, index) => (
                    <img
                      key={index}
                      src={`${baseUrl}/${imagePath}`}
                      alt={`Asset ${index + 1}`}
                      className="w-full h-auto rounded-lg border border-gray-300"
                    />
                    ))}
                  </div>
                  )}
                </div>

                <div className="flex flex-row-reverse mt-5">
                  <button
                    type="button"
                    className="mt-3 ml-3 inline-flex w-1/4 justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
                    onClick={() => setOpen(false)}
                    ref={cancelButtonRef}
                  >
                    Close
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
